import React from "react";
import "./input.css";

const Input = ({ type, name, value, error, placeholder, onChange }) => {
  return (
    <>
      <input
        type={type}
        name={name}
        className="form-control"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        autoComplete="current-password"
      />
      {error && <div className="alert">{error}</div>}
    </>
  );
};

export default Input;
